import React from "react";

/**
 * Renders plain text preserving paragraphs.
 * Splits by blank line (\n\n) into paragraphs; single \n becomes a soft line break.
 * Empty / null input renders nothing.
 */
export default function RichText({ text, className = "" }) {
  if (!text || !text.trim()) return null;
  const paragraphs = text
    .replace(/\r\n/g, "\n")
    .split(/\n{2,}/)
    .map((p) => p.trim())
    .filter(Boolean);

  return (
    <div className={className}>
      {paragraphs.map((p, i) => (
        <p key={i} className="mb-4 last:mb-0 text-stone-700 leading-relaxed whitespace-pre-line">
          {p}
        </p>
      ))}
    </div>
  );
}
